import { List, ListItem, Typography } from "@mui/material";

import { ProtocolVisitTimeslot } from "../../types/ProtocolVisitTimeslot";

type Props = {
    timeslots: ProtocolVisitTimeslot[];
};

export default function ProtocolVisitTimeslotSummary({ timeslots }: Props) {
    return (
        <List sx={{ p: 0, m: 0 }}>
            {timeslots.map(timeslot => (
                <ListItem key={timeslot.id} sx={{ p: 0, m: 0 }}>
                    <Typography variant="caption">
                        <strong>
                            {timeslot.startRelativeTo}{" "}
                            {timeslot.maxStartOffset > 0
                                ? `+${timeslot.maxStartOffset}h`
                                : timeslot.maxStartOffset < 0
                                  ? `${timeslot.maxStartOffset}h`
                                  : ""}
                        </strong>{" "}
                        until{" "}
                        <strong>
                            {timeslot.endRelativeTo}{" "}
                            {timeslot.minEndOffset > 0
                                ? `+${timeslot.minEndOffset}h`
                                : timeslot.minEndOffset < 0
                                  ? `${timeslot.minEndOffset}h`
                                  : ""}
                        </strong>
                    </Typography>
                </ListItem>
            ))}
        </List>
    );
}
